import { Currency } from "@redotech/money/currencies";
import {
  createCurrencyConverter,
  CurrencyConverter,
} from "@redotech/money/exchange";
import { lazy } from "@redotech/util/cache";
import { createContext, ReactNode, useContext, useMemo } from "react";
import { RedoMerchantRpcClientContext } from "./rpc-client";

export const CurrencyExchangeContext = createContext<
  () => Promise<CurrencyConverter>
>(async () => {
  throw new Error("Not provided");
});

export const CurrencyExchangeProvider = ({
  children,
}: {
  children: ReactNode | ReactNode[];
}) => {
  const rpcClient = useContext(RedoMerchantRpcClientContext);
  const currencyConverter = useMemo(
    () =>
      lazy(async () => {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const response = await rpcClient!.getExchangeRates(null);
        return createCurrencyConverter(
          // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
          // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
          new Map(Object.entries(response.data) as [Currency, number][]),
        );
      }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  return (
    <CurrencyExchangeContext.Provider value={currencyConverter}>
      {children}
    </CurrencyExchangeContext.Provider>
  );
};
